/**************************************************
 * Nombre:       Formulario_Producto_Variante_Variante
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import {Inventory2Outlined, ScaleOutlined, TimesOneMobiledataOutlined} from '@mui/icons-material'

const Formulario_Producto_Variante_Variante = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoTexto Icono={TimesOneMobiledataOutlined} nombre={'Medida'}
                                  dato={'medida'} {...props}
                                  ejemplo={'Unidad'}
                                  requerido={'Campo Requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={Inventory2Outlined} nombre={'Nombre de la variante'}
                                  dato={'nombre'} {...props}
                                  ejemplo={'100Gr'}
                                  requerido={'Campo Requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero nombre={'Valor de la variante'}
                                   dato={'valor'} {...props}
                                   requerido={'Campo Requerido'}
                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoTexto
                        Icono={ScaleOutlined}
                        nombre={'Peso empacado (mgr)'}
                        dato={'peso'} {...props}
                        ejemplo={'1000'}
                        type={'number'}
                        requerido={'Campo Requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Variante_Variante